export enum AccountType {
  Company = 'Company',
  Personal = 'Personal',
}

export enum AccountLanguage {
  DeDe = 'DeDe',
  EnUs = 'EnUs',
  EsEs = 'EsEs',
  FrFr = 'FrFr',
  ItIt = 'ItIt',
  PtBr = 'PtBr',
}
